// @ts-check
import React from "react";
import SetupView from "./SetupView";

import { ApiService, DataStore } from "../../services/AxoServices";

import { withRouter, Consumer } from "../../utilities/LexUtilities";

class SetupContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      libraryFileNames: [],
      groupMembers: [],
      paymentRequests: [],
    };
  }

  componentDidMount() {
    ApiService.getLibraryFileNames().then((libraryFileNames) => {
      this.setState({ libraryFileNames });
    });

    this.fetchRequests();

    DataStore.initializeUserProfile();
    DataStore.initializeUserSettings();
    DataStore.fetchUserSubscription();
    DataStore.fetchStorageInformation();
    DataStore.fetchSubscriptionPlans();
    DataStore.initializeUserGroup();
    DataStore.fetchGlobalSettings();
  }

  getGroupMembers = () => {
    ApiService.getGroupMembers().then((groupMembers) => {
      this.setState({ groupMembers });
    });
  };

  fetchRequests = () => {
    ApiService.getPaymentRequestsForCurrentUser().then((paymentRequests) => {
      this.setState({ paymentRequests });
    });
  };

  clearGroupMembers = () => {
    this.setState({ groupMembers: [] });
  };

  removeGroupMember = (userProfileId) => {
    ApiService.removeGroupMember(userProfileId).then((response) => {
      if (response.ok) {
        this.getGroupMembers();
        DataStore.fetchUserGroup();
      }
    });
  };

  render() {
    return (
      <Consumer>
        {(store) => {
          return (
            <SetupView
              {...this.state}
              locale={store.locale}
              userProfile={store.userProfile}
              userGroup={store.userGroup}
              userSettings={store.userSettings}
              userSubscription={store.userSubscription}
              storageInformation={store.storageInformation}
              documentMap={store.documentMap}
              subscriptionPlans={store.subscriptionPlans.filter((sub) => {
                return sub.type === "Standard";
              })}
              fetchRequests={this.fetchRequests}
              globalSettings={store.globalSettings}
              theme={store.theme}
              getGroupMembers={this.getGroupMembers}
              clearGroupMembers={this.clearGroupMembers}
              removeGroupMember={this.removeGroupMember}
            />
          );
        }}
      </Consumer>
    );
  }
}

export default withRouter(SetupContainer);
